const TOGGLE_QUIZ_TEAM_SET_UP_VISIBLE = 'TOGGLE_QUIZ_TEAM_SET_UP_VISIBLE'
const CLOSE_QUIZ_TEAM_SET_UP_PANEL = 'CLOSE_QUIZ_TEAM_SET_UP_PANEL'
const SET_RIGHT_PANEL_CONTAINER_ACTIVE_TAB = 'SET_RIGHT_PANEL_CONTAINER_ACTIVE_TAB'
const TAB_AUDIO_SLIDE = 'Tab Audio Slide'
const TAB_AUDIO_PRESENTATION = 'Tab Audio Presentation'
const ACTIVE_TABS = { TAB_AUDIO_SLIDE, TAB_AUDIO_PRESENTATION }

// state
const _state = {
  isQuizTeamSetUpVisible: false,
  activeTabs: ACTIVE_TABS,
  activeTab: null,
}

// getters
const _getters = {
  isSettingsContentVisible(_, __, rootState) {
    const isTabSettingsActive = rootState.rightNav.rightNavActiveTab === rootState.rightNav.rightNavTabNames.SETTINGS
    return rootState.slideActive.activeTab === 6 && isTabSettingsActive
  },
  isQuizTeamSetUpVisible(state, getters) {
    return state.isQuizTeamSetUpVisible && getters.isSettingsContentVisible
  },
  rightPanelContainerActiveTabs(state) {
    return state.activeTabs
  },
  activeTab(state) {
    return state.activeTab
  },
  isTabAudioSlideActive(state, _, rootState) {
    const isRightNavAudioActive = rootState.rightNav.rightNavActiveTab === rootState.rightNav.rightNavTabNames.AUDIO
    if (isRightNavAudioActive && !rootState.rightPanelContainer.activeTab) {
      return true
    }
    return state.activeTab === state.activeTabs.TAB_AUDIO_SLIDE
  },
  isTabAudioPresentationActive(state) {
    return state.activeTab === state.activeTabs.TAB_AUDIO_PRESENTATION
  },
}

// mutations
const mutations = {
  [TOGGLE_QUIZ_TEAM_SET_UP_VISIBLE](state) {
    state.isQuizTeamSetUpVisible = !state.isQuizTeamSetUpVisible
  },
  [CLOSE_QUIZ_TEAM_SET_UP_PANEL](state) {
    state.isQuizTeamSetUpVisible = false
  },
  [SET_RIGHT_PANEL_CONTAINER_ACTIVE_TAB](state, tabName) {
    state.activeTab = tabName
  },
}

// actions
const actions = {
  toggleQuizTeamSetUpVisibleAction({ commit }) {
    commit(TOGGLE_QUIZ_TEAM_SET_UP_VISIBLE)
  },
  closeQuizTeamSetUpPanelAction({ commit }) {
    commit(CLOSE_QUIZ_TEAM_SET_UP_PANEL)
  },
  setRightPanelContainerActiveTabAction({ commit }, tabName) {
    commit(SET_RIGHT_PANEL_CONTAINER_ACTIVE_TAB, tabName)
  },
}

export default {
  namespaced: true,
  state: _state,
  getters: _getters,
  mutations,
  actions,
}
